const getRatioPart = (ratio, part) => {
    if (part === 'left') {
        return parseInt(ratio.substring(ratio.indexOf(':') + 1));
    }
    return parseInt(ratio.substring(0, ratio.indexOf(':')));
};
export default getRatioPart;
